import React from "react";
import {tableIcons} from "./icons";
import MaterialTable from 'material-table';
import MTableToolbar from 'material-table/dist/components/m-table-toolbar';
import TablePagination from '@material-ui/core/TablePagination';
import debounce from 'lodash-es/debounce';
import { loadSalesHistory, updateApplication } from "../../api/applications";
import { loadInsuranceAgencies, loadServiceAgencies } from "../../api/agencies";
import { UserContext, isAdministrator } from "../../context/user";
import { ApplicationPreview } from "./ApplicationPreview/ApplicationPreview";
import { ApplicationFilter } from "./ApplicationFilter/AplicationFilter";
import cn from './ApplicationHistoryTable.module.scss';

const columns = [
  {title: 'MemberID', field: 'member_id'},
  {title: 'First Name', field: 'first_name'},
  {title: 'Last Name', field: 'last_name'},
  {title: 'Phone', field: 'phone', cellStyle: { whiteSpace: 'nowrap'}},
  {title: 'Email', field: 'email_address'},
  {title: 'Gender', field: 'gender'},
  {title: 'Status', field: 'status'},
  {title: 'Membership Date', field: 'membership_date', cellStyle: { whiteSpace: 'nowrap'}},
  {title: 'Address 1', field: 'address_1'},
  {title: 'Address 2', field: 'address_2'},
  {title: 'City', field: 'city'},
  {title: 'State', field: 'state'},
  {title: 'Zip', field: 'postal_code'},
  {title: "Contract Number", field: 'contract_number'},
];

export class ApplicationHistoryTable extends React.PureComponent {
  static contextType = UserContext;

  state = {
    data: [],
    searchQuery: '',
    isLoading: false,
    totalCount: 0,
    page: 0,
    pageSize: 10,
    filter: {},
    insuranceAgencies: [],
    serviceAgencies: [],
  };

  ToolbarComponent = (props) => {
    return (
      <div className={cn.toolBar}>
        <MTableToolbar {...props} onSearchChanged={this.handleSearchChange} searchText={this.state.searchQuery} />
      </div>
    )
  };
  FilterComponent = () => (
      <ApplicationFilter
        onSubmit={this.handleFilterChange}
        insuranceAgencies={this.state.insuranceAgencies}
        serviceAgencies={this.state.serviceAgencies}
      />
    );

  componentDidMount() {
    this.loadData();
    Promise.all([loadInsuranceAgencies(), loadServiceAgencies()]).then(result => {
      const [insuranceAgencies, serviceAgencies] = result;
      this.setState({
        insuranceAgencies,
        serviceAgencies,
      })
    });
  }

  handlePageChange = (event, page) => {
    this.setState({ page }, this.loadData);
  };

  handleSearchChange = (searchQuery) => {
    this.setState({ searchQuery, page: 0 }, this.loadDataDebounced)
  };

  handlePageSizeChange = (event) => {
    const { value: pageSize } = event.target;
    this.setState({ pageSize, page: 0 }, this.loadData);
  };

  handleEdit = async (updatedApplication, oldApplication) => {
    const { data } = this.state;
    this.setState({ isLoading: true });
    try {
      await updateApplication(updatedApplication);
      this.setState({
        data: data.map((application) => {
          return application === oldApplication ? updatedApplication : application;
        })
      });
    } catch (err) {
      console.error(err);
    }
    this.setState({ isLoading: false });
  };

  handleFilterChange = (filter) => {
    this.setState({ filter }, this.loadData);
  };

  async loadData() {
    const { page, pageSize, searchQuery, filter } = this.state;
    this.setState({ isLoading: true });
    try {
      const { data, count } = await loadSalesHistory({
        searchQuery,
        filter,
        limit: pageSize,
        offset: pageSize * page
      });
      this.setState({ data, totalCount: count, isLoading: false });
    } catch (err) {
      console.error(err);
    }
    this.setState({ isLoading: false });
  }

  loadDataDebounced = debounce(this.loadData, 500);

  render() {
    const { data, totalCount, page, isLoading, pageSize, insuranceAgencies, serviceAgencies } = this.state;
    const user = this.context;

    return (
      <React.Fragment>
        <MaterialTable
          title="Members"
          icons={tableIcons}
          style={{ padding: "0 10px"}}
          columns={columns}
          data={data}
          isLoading={isLoading}
          options={{
            pageSize,
            padding: 'dense',
            sorting: false,
          }}
          detailPanel={application => (
            <ApplicationPreview
              editable={ isAdministrator(user) ? { onRowUpdate: this.handleEdit } : undefined }
              application={application}
              insuranceAgencies={insuranceAgencies}
              serviceAgencies={serviceAgencies}
              handleEdit={this.handleEdit}
            />
          )}
          components={{
            Pagination: () => {
              return (
                <TablePagination
                  classes={{ root: cn.pagination }}
                  rowsPerPageOptions={[5, 10, 25]}
                  count={totalCount}
                  rowsPerPage={pageSize}
                  page={page}
                  onChangePage={this.handlePageChange}
                  onChangeRowsPerPage={this.handlePageSizeChange}
                />
              )
            },
            Toolbar: this.ToolbarComponent,
          }}
          actions={[
            {
              icon: this.FilterComponent,
              onClick: () => {},
              isFreeAction: true,
            }
          ]}
        />
      </React.Fragment>
    )
  }
}
